import styles from "./NavigationTop.module.css"
import { Link } from "react-router-dom"
import { breadcrumbsvg } from "../../assets/svg/svgimages"
import { getLensDisplayName, getLensSeriesKey } from "../../utils/lens";

const NavigationTop = ({ title, text, singleProduct, singleTutorial, yourCustomClass, yourCustomClassTwo, productBreadcrumbLabel }) => {
    const lensSeriesKey = getLensSeriesKey(singleProduct?.lens);
    
    return (
        <section className={`height ${styles.main} ${yourCustomClass || ''} ${yourCustomClassTwo || ''}`}>
            {singleProduct ? (
                /* The catalog is the homepage now, so "Home" and "Library"
                   would be the same URL twice. They are collapsed into one
                   crumb, matching the BreadcrumbList in seo_views.py. */
                <div className={styles.breadcrumbs}>
                    <Link to="/">Library {breadcrumbsvg}</Link>
                    <Link to={`/?camera=${singleProduct.camera.id}`}>{singleProduct.camera.model_name} {breadcrumbsvg}</Link>
                    <Link to={lensSeriesKey ? `/?lens_series=${encodeURIComponent(lensSeriesKey)}` : "/"}>{getLensDisplayName(singleProduct.lens, { includeFocal: false })} {breadcrumbsvg}</Link>
                    <p>{productBreadcrumbLabel || `Distortion grid pack for ${singleProduct.productTitle || `${singleProduct.camera.model_name} ${getLensDisplayName(singleProduct.lens, { includeBrand: false })}`}`}</p>
                </div>
            ) : singleTutorial ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <Link to="/tutorials">Tutorials {breadcrumbsvg}</Link>
                    <p>{singleTutorial}</p>
                </div>
            ) : title === "Affiliate program" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>Affiliate program</p>
                </div>
            ) : title === "FAQ" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>FAQ</p>
                </div>
            ) : title === "Top Contribution" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>Top Contribution</p>
                </div>
            ) : title === "Tutorials" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>Tutorials</p>
                </div>
            ) : title === "News" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>News</p>
                </div>
            ) : title === "How it works" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                    <p>How it works</p>
                </div>
            ) : title === "Error" ? (
                <div className={styles.breadcrumbs}>
                    <Link to="/">Home {breadcrumbsvg}</Link>
                </div>
            ) : (
                ""
            )}
            {title && <h2 className="h2-bold">{title}</h2>}

            {text && <div className={`h4-light ${styles.text}`}>{text}</div>}
        </section>
    );
}

export default NavigationTop
